import { render, staticRenderFns } from "./confirmMessageDialog.vue?vue&type=template&id=fab57640&scoped=true"
import script from "./confirmMessageDialog.vue?vue&type=script&lang=js"
export * from "./confirmMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmMessageDialog.vue?vue&type=style&index=0&id=fab57640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab57640",
  null
  
)

export default component.exports